import React, { Fragment, useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { i18nextLng } from "../../config/sessionKeys";
import langList from "../../lang/langList.json"
import './scss/Language.scss'

const Language = () => {
    const { i18n } = useTranslation();
    const [selected, setSelected] = useState(localStorage.getItem(i18nextLng));
    const changeLanguage = lng => {
        i18n.changeLanguage(lng);
        setSelected(lng);
    };

    return (
        <Fragment>
            <div className="multi-lang">
                <span>{selected === null ? 'en' : selected.includes('en-') ? 'en' : selected === 'en' ? 'en' : 'বাং'}  <i className="bi bi-chevron-down"></i></span>
                <ul className="multi-lang-list">
                    {
                        langList?.map((item, index) => {
                            return <li onClick={() => changeLanguage(item.code)} key={index}>
                                <a href={void 0} data-lng={item.code}>
                                    <i className={`flag-icon ${item.flag_icon_class}`} /> {item.name}
                                </a>
                            </li>
                        })
                    }
                </ul>
            </div>
        </Fragment>
    );
};


export default Language;
